// extracted by mini-css-extract-plugin
export var snsIcon = "SnsLink-module--snsIcon--0d866";
export var snsIconContainer = "SnsLink-module--snsIconContainer--3ba31";
export var snsSubIcon = "SnsLink-module--snsSubIcon--2ba37";